import { ModalFileUpload } from "./modals/modalFileUpload";

export class ModAttachment {

   constructor(settings, app) {

      this.app = app;
      this.dm = this.app.dm;
      this.uploading = false;

      let defaults = {
         maxFileSize: 10000,
         onChange: function(items) { return null; },
         itemTextValue: (file) => file.name,
         itemSortValue: (file) => file.name,
         itemId: (file) => file.id
      };

      this.set = Object.extend(true, defaults, settings);

      this.elMain = HTMLElement.createFromHTML(
        `<div class="mod-attachment">
            <div class="offline-message">Dateien können nur bei bestehender Internetverbindung angehängt werden.</div>
            <div class="multi-select">
               <input type="file" class="file-open" name="file" accept="*" multiple="multiple" style="display: none;"></input>
               <div class="selected"></div>
               <div class="btn-add"><i class="icon-plus"></i></div>
            </div>
         </div>`
      );

      this.elSelected = this.elMain.querySelector('.selected');
      this.elBtnAdd   = this.elMain.querySelector('.btn-add');
      this.elFiles    = this.elMain.querySelector('.file-open');
      
      if (this.app.dm.online) {
         this.elFiles.onchange = (event) => this.addFiles(event);
         this.elBtnAdd.onclick = () => this.elFiles.click();
         this.elSelected.onclick = () => this.elFiles.click();
      }
      else {
         this.elMain.querySelector('.offline-message').style.display = 'block';
      }

   }
   
   renderItem(item) {

      let elSelected = HTMLElement.createFromHTML(
         '<div class="selected-item">'
         + '   <div class="name">' + this.set.itemTextValue(this.set.addItem ? item.data : item) + '<div class="progress"></div></div>'
         + '   <div class="btn-delete"><div class="font-icon icon-cross"></div></div>'
         + '</div>'
      );

      elSelected.setData('item', item);

      return elSelected;

   }

   addItems(items, triggerChange) {

      let elSelectedItems = [];

      for (let item of items) {

         let elSelected = this.renderItem(item);

         elSelected.querySelector('.btn-delete').onclick = (event) => {
            event.stopPropagation();
            event.currentTarget.parentNode.remove();
            this.set.onChange(this.getSelectedItems());
         };
         this.elSelected.appendChild(elSelected);

         elSelectedItems.push(elSelected);

      }

      //if (triggerChange) this.set.onChange(this.getSelectedItems());

      return elSelectedItems;

   }

   search(text) {
      this.loadList(text);
   }

   setSelection(items) {

      this.elSelected.empty();

      this.addItems(items, true);

   }

   getSelectedItemIds() {
      let selected = this.getSelectedItems();
      return selected.map(item => this.set.itemId(this.set.addData ? item.data : item));
   }

   getSelectedItems() {
      let selected = [];

      this.elSelected.querySelectorAll('.selected-item').forEach(elSelected => {
         selected.push(elSelected.getData('item'));
      });

      return selected;
   }


   addFiles(event) {

      let files = Array.from(this.elFiles.files);

      new ModalFileUpload(this.app, files, this.set, (files) => {
         this.addItems(files);
      });


      /*
      for (const file of files) {
         if (file.size > this.set.maxFileSize) {
            const msg = `Dateien dürfen nicht größer als <b>${(this.set.maxFileSize/(1024*1024)).toFixed(2)} MB</b> sein.`;
            toast.alert(msg);
            logger.error(msg);
            return;
         }
      }

      const elItems = this.addItems(files);
      let uploads = [];      

      for (let i=0; i<files.length; ++i) {
         const file = files[i];
         let data = new FormData();
         data.append('file', file);
         data.append('localIndex', i);
         uploads.push(this.dm.sinFileUpload(data, (progress) => { elItems[i].querySelector('.progress').style.width = (progress*100) + '%'; }));
      }

      Promise.all(uploads)
      .then(responses => {
         for (let file of responses.map(i => i.data)) {
            elItems[file.localIndex].setData('item', file);
         }
         this.loading = false;         
      })
      .catch(e => {
         toast.alert(e, { duration: 8000 });
         logger.error(e);
      });
      */


   }

   getElement() {
      return this.elMain;
   }

   appendTo(parent) {
      this.elMain = parent.appendChild(this.elMain);
   }

}
